import Vue from 'vue'
import { catalogMonetary } from '@/util/catalog'

export const splitMode = (amount, type) => {
  if (type != null) {
    return type
      ? `${amount}%`
      : catalogMonetary(amount)
  } else {
    return '---'
  }
}
